import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  OnInit,
  viewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ContentService } from '../../../services/content.service';
import { BaseComponent } from '@shared/classes/base.class';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BehaviorSubject, take } from 'rxjs';
import { IFooterResponse } from '@shared/constants/models.const';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { HelperService } from '../../../services/helper.service';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'app-footer',
  imports: [
    SafeHtmlPipe,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent extends BaseComponent implements OnInit {
  mainFooter = viewChild<ElementRef>('mainFooter');
  currFr = '';
  HELPER = inject(HelperService);
  CONTENT = inject(ContentService);
  footerData = new BehaviorSubject<IFooterResponse | null>(null);

  override ngOnInit() {
    super.ngOnInit();
    this.getData();
    this.footerData.subscribe(data => {
      setTimeout(() => {
        if (data) this.addOneTrustItem();
      }, 300);
    });
  }

  override getData(): void {
    if ((this.currFr !== this.HELPER.frLoc) || !this.footerData) {
      this.CONTENT.getFooter()
        .pipe(take(1))
        .subscribe(data => {
          this.footerData.next(data);
          this.currFr = this.HELPER.frLoc;
          this.addOneTrustItem();
        });
    }
  }

  addOneTrustItem() {
    const el = this.mainFooter()?.nativeElement;
    if (!el) return;
    const footerItems = el.querySelector('ul');
    if (!footerItems) return;

    const newListItem = document.createElement('li');
    const spanElement = document.createElement('span');
    spanElement.className = 'like-a';
    spanElement.textContent = 'Cookie settings';
    newListItem.appendChild(spanElement);
    newListItem.addEventListener('click', () => {
      (window as any).OneTrust?.ToggleInfoDisplay?.();
    });

    footerItems.appendChild(newListItem);
  }

}
